import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { withRouteData } from 'react-static';
import styled from 'styled-components';

import FeaturedProducts from './FeaturedProducts';
import HomeHero from './HomeHero';
import HomeNewsCard from './HomeNewsCard';
import PackageCard from './PackageCard';
import Page from '../global/Page';
import ProductCategories from './ProductCategories';
import VideosCard from './VideosCard';
import LocatorCallout from './LocatorCallout';
import AboutCard from './AboutCard';

const HomePage = styled(Page)`
  background-color: ${p => p.theme.color.tertiary};
`;

const SliceColor = styled.div`
  background-color: #ebebeb;
  padding-bottom: 1px;
`;

const Home = ({ articles, productCategories }) => (
  <HomePage>
    <Helmet
      title="Hot Water Solutions Since 1939 | Lochinvar"
      meta={[
        { property: 'og:title', content: 'Home' },
        {
          property: 'description',
          content:
            'Lochinvar is a premier provider of commercial and residential water heating solutions, from boilers to water heaters to cogeneration products and more.'
        }
      ]}
    />
    <HomeHero />
    <PackageCard />
    <FeaturedProducts />
    <LocatorCallout />
    <ProductCategories productCategories={productCategories} />
    <SliceColor>
      <AboutCard />
      <VideosCard />
      {articles && <HomeNewsCard news={articles} />}
    </SliceColor>
  </HomePage>
);

Home.propTypes = {
  articles: PropTypes.array,
  productCategories: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default withRouteData(Home);
